var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.loader)?_c('div',{staticClass:"roller2"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }